import gql from 'graphql-tag';

export const details = gql`
  query FetchLinkDetailsQuery($url: String!) {
    details: fetchMetaDataDetails(url: $url)
  }
`;
